let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5odbj"), load("fJlx3"), load("7A5zJ"), load("lPQcc"), load("6lM2n")]).then(() => parcelRequire('esDVy'));